import { ReactElement } from 'react';
import { CopyToClipboard, Link } from '@amzn/awsui-components-react-v3';
import { formatString } from './formatString';

// Split comma/semicolon-separated emails into individual mailto links, one per line (separate <div>).
export const formatEmails = (emails?: string | null): ReactElement | string => {
    const parsed = (emails ?? '')
        .split(/[,;]/)
        .map((e) => e.trim())
        .filter(Boolean);

    if (!parsed.length) return formatString(emails?.trim());

    return (
        <>
            {parsed.map((email, idx) => (
                <div key={`${email}-${idx}`}>
                    <Link
                        variant="primary"
                        href={`mailto:${email}`}
                        ariaLabel={`Email ${email}`}
                    >
                        {email}
                    </Link>
                    <CopyToClipboard
                        variant="icon"
                        textToCopy={email}
                        copyButtonAriaLabel={`Copy ${email}`}
                        copySuccessText="E-mail copied"
                        copyErrorText="E-mail failed to copy"
                    />
                </div>
            ))}
        </>
    );
};
